import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {useParams} from "react-router-dom";
import {Button, Col, FormControl, FormLabel, Row} from "react-bootstrap";
import {PasswordControl, UsernameControl} from "../components/controls/FormControls";
import {useCallback, useState} from "react";
import {useForm} from "../utilities/formutilities";
import {useResetPasswordMutations} from "../api/resetpasswordsapi";

export function PasswordResetPage() {
    const {token} = useParams();
    const [succec, setSucces] = useState(false);
    const [error, setError] = useState(false);

    const initialObjectInitializer = useCallback(() => ({memberNumber: "", password: "", token: token}), []);
    const {onChange, tempObject} = useForm(initialObjectInitializer);
    const {resetPassword} = useResetPasswordMutations();
    console.log(tempObject)

    async function handleSubmit(e) {
        const result = await resetPassword(tempObject);
        console.log(result)
        if (result) {
            if (result.used === true) {
                setSucces(true);
                setError(false);
            }
            if (result.used === false) {
                setError(true);
            }
        }

    }

    return <BasePageLayout>
        <Row className={"g-0 justify-content-center"}>
            <Col xs={12} className={'text-center'}>
                <h3>Reset wachtwoord</h3>
            </Col>
            <Col xs={12} md={6} xl={3}>
                <div className={"text-start"}
                     onSubmit={e => handleSubmit(e)}>
                    <UsernameControl fieldname={"memberNumber"} onChange={onChange} tempObject={tempObject}/>
                    <PasswordControl title={"Nieuw wachtwoord"} onChange={onChange} tempObject={tempObject}/>
                    <FormLabel>Herhaal nieuwe wachtwoord</FormLabel>
                    <FormControl placeholder={"Herhaal wachtwoord"} type={'password'}
                                 onChange={e => onChange(e, 'passwordRepeat')}/>
                    {error ? <p className={'text-break'}>Lidnummer niet juist of fout bij het verzenden.</p> : ""}
                    {succec ? <div>
                        <p>Wachtwoord is gereset. U kan zich nu inloggen met het nieuwe wachtwoord.</p>
                        <div className={"text-center"}>
                            <Button
                                href={"/login"}>Login</Button>
                        </div>
                    </div> : ""}
                    <Col className={"text-center mb-4"}>
                        <Button hidden={succec} disabled={tempObject.password !== tempObject.passwordRepeat}
                                type={"submit"}
                                className={"mt-2"} onClick={e => handleSubmit(e)}>Reset</Button>
                    </Col>
                </div>
            </Col>
        </Row>
    </BasePageLayout>
}